// removed by extract-text-webpack-plugin
module.exports = {"searchHeaderSection":"_3c5Lr"};